import { SOCKETIO_RECONNECT_INTERVAL } from '../../../constants';
import { getAccessToken } from '../../core/auth/utils';
import { eventEmitter } from '../../services/event-emitter-service';
import { COMMUNICATION_EVENT, SOCKET_EVENTS } from '../../modules/Feeds/constants';

const URL = process.env.REACT_APP_MERCURY_URL;
const COMMUNICATION_NAMESPACE_URL = `${URL}/communication`;
const { io } = require('socket.io-client');

let communicationSocket = null;
let isConnecting = false;
let pendingRooms = []; // Store rooms to join after connection

const callbacks = {};

function establishCommunicationSocketConnection(token) {
  // If socket exists but is disconnected, clean it up
  if (communicationSocket) {
    communicationSocket.removeAllListeners();
    communicationSocket.disconnect();
    communicationSocket = null;
  }

  communicationSocket = io(COMMUNICATION_NAMESPACE_URL, {
    extraHeaders: {
      Authorization: `Bearer ${token}`,
    },
    autoConnect: true,
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: SOCKETIO_RECONNECT_INTERVAL,
    timeout: 20000,
  });

  setupSocketEvents();
}

function setupSocketEvents() {
  communicationSocket.on('connect', function () {
    console.log(`COMMUNICATION Socket ${communicationSocket.id} CONNECTED`);
    rejoinPendingRooms();
  });

  communicationSocket.on('disconnect', function (reason) {
    console.log(`Communication Socket ${communicationSocket.id} DISCONNECTED. Reason: ${reason}`);
    // Don't set communicationSocket to null here as it might reconnect automatically
  });

  communicationSocket.on('connect_error', function (error) {
    console.error('Communication Socket connection error:', error);
  });

  communicationSocket.on('reconnect', function (attemptNumber) {
    console.log(`Socket reconnected after ${attemptNumber} attempts`);
    rejoinPendingRooms();
  });

  communicationSocket.on('reconnect_error', function (error) {
    console.error('Communication Socket reconnection error:', error);
  });

  communicationSocket.on('reconnect_failed', function () {
    console.error('Communication Socket reconnection failed');
    // Reset the socket instance so a new connection can be established
    communicationSocket = null;
  });

  communicationSocket.on(SOCKET_EVENTS.COMMUNICATION_EVENT, (data) => {
    console.log('Communication event received:', data);
    eventEmitter.emit(SOCKET_EVENTS.COMMUNICATION_EVENT, data);
  });
}





export async function joinMeetingRoom(roomId) {
  const roomData = {
    roomId,
  };

  // Always re-establish connection when explicitly called
  if (!communicationSocket || !communicationSocket.connected) {
    // Add to pending rooms queue if not already present (prevent duplicates)
    const existingRoom = pendingRooms.find((room) => room.roomId === roomId);
    if (!existingRoom) {
      pendingRooms.push(roomData);
    }
    const token = await getAccessToken();
    establishCommunicationSocketConnection(token);
    // If socket was just created, wait for it to connect
    if (!communicationSocket.connected) {
      await new Promise((resolve) => {
        communicationSocket.once('connect', resolve);
      });
    }
  }

  // Join the room immediately if socket is connected
  if (communicationSocket && communicationSocket.connected) {
    joinRoom(roomData.roomId);
  }
}

// Helper function to rejoin all pending rooms
function rejoinPendingRooms() {
  if (pendingRooms.length > 0) {
    const roomsToJoin = [...pendingRooms]; // Create a copy
    pendingRooms = []; // Clear the pending rooms array

    // Join all pending rooms
    roomsToJoin.forEach((roomData) => {
      joinRoom(roomData.roomId);
    });
  }
}

// Helper function to handle the actual room joining logic
function joinRoom(roomId) {
  if (!roomId) {
    //IF ROOMID IS NOT SPECIFIED THEN DEFAULT IT TO SOCKET.ID
    roomId = communicationSocket.id;
  }
  communicationSocket.emit('message', {
    action: 'join_room',
    room_id: roomId,
  });
}





export function registerAction(callback) {
  callbacks[callback.event] = callback.action;
}

export function removeAction(event) {
  callbacks[event] = false;
}

export function disconnectCommunicationSocket() {
  if (communicationSocket) {
    communicationSocket.removeAllListeners();
    communicationSocket.disconnect();
    communicationSocket = null;
  }
}
